import { render, staticRenderFns } from "./CreatorHeader.vue?vue&type=template&id=2651241f&scoped=true&"
import script from "./CreatorHeader.vue?vue&type=script&lang=js&"
export * from "./CreatorHeader.vue?vue&type=script&lang=js&"
import style0 from "./CreatorHeader.vue?vue&type=style&index=0&id=2651241f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651241f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
